import { render, staticRenderFns } from "./AccessDenied.vue?vue&type=template&id=0a785742&scoped=true"
import script from "./AccessDenied.vue?vue&type=script&lang=ts"
export * from "./AccessDenied.vue?vue&type=script&lang=ts"
import style0 from "./AccessDenied.vue?vue&type=style&index=0&id=0a785742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a785742",
  null
  
)

export default component.exports